import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface PerPayPeriodTextState {
  perPayPeriodText: string;
}

const initialState: PerPayPeriodTextState = {
  perPayPeriodText: 'Per Pay Period',
};

const perPayPeriodTextSlice = createSlice({
  name: 'perPayPeriodText',
  initialState,
  reducers: {
    setPerPayPeriodText: (state, { payload }: PayloadAction<string>) => {
      state.perPayPeriodText = payload;
    },
  },
});

const { reducer, actions } = perPayPeriodTextSlice;

export const { setPerPayPeriodText } = actions;

export const perPayPeriodTextReducer = reducer;
